// extracted by mini-css-extract-plugin
export default {"addBlock":"MessageContent_addBlock__K-1dA"};